import React from "react";

/**
 * Raimi-era Spider-Man logo (long-legged tribal spider).
 * Uses the uploaded asset image; a CSS filter tints the silhouette so it
 * matches its parent's foreground color context.
 *
 * Props:
 *   className - Tailwind size classes (default w-6 h-6).
 *   color     - "white" (default), "black", or "currentColor" (approx).
 */
const SPIDER_ASSET =
  "https://customer-assets-rejwkqb3.emergentagent.net/job_money-flow-781/artifacts/dfermf2e_s-l400.png";

export default function SpiderLogo({ className = "w-6 h-6", color = "white" }) {
  // Turn the black-on-transparent PNG into a pure silhouette of the requested color.
  let filter;
  if (color === "black" || color === "#000000" || color === "#000") {
    filter = "brightness(0) saturate(100%)";
  } else if (color === "white" || color === "#ffffff" || color === "#fff") {
    filter = "brightness(0) saturate(100%) invert(1)";
  } else {
    // For an arbitrary color, approximate white then let parent tint via mix-blend if needed.
    filter = "brightness(0) saturate(100%) invert(1)";
  }

  return (
    <img
      src={SPIDER_ASSET}
      alt=""
      aria-hidden="true"
      draggable="false"
      className={`${className} object-contain select-none pointer-events-none`}
      style={{ filter }}
    />
  );
}
